<template>
    <div>
        <div class="bg-white p-5 pb-1 mb-3 rounded">
            <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
                <div class="justify-content-star d-flex">
                    <h3><strong style="color:#1A0054">Lista de cursos</strong></h3>
                </div>
                <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid">
                    <search-input-component :search="search" @onSearch="onFilterSearch($event)"></search-input-component>

                    <select
                        v-model="selectedTableType"
                        class="form-control bg-utel-v2-secondary sin-borde rounded-8 mx-1 my-sm-2 pt-2"
                        v-on:change="onTableTypeChange"
                        style="width:auto;"
                    >
                        <option value="coursesroutes">Cursos de Utel X</option>
                        <option value="owncourses">Cursos propios</option>
                    </select>

                    <a :href="url_report" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2">Descargar reporte</a>
                    <a :href="url_report_detail" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2 d-none">Descargar reporte detallado</a>
                    <a href="#" @click="enviarReporte()" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2 ">Descargar reporte detallado</a>
                    <a href="#create_new_own_course" class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2">Crear curso propio</a>
                </div>
            </div>
            <v-data-table
                :headers="allHeadersTabs"
                :items="desserts"
                item-key="name"
                :search="search"
                :loading="loadingTable"
                class="elevation-1 table text-center align-middle small"
                loading-text="Cargando..."
                mobile-breakpoint="0"
                :header-props="{
                    sortIcon: 'fa-solid fa-sort-amount-desc'
                }"
                :footer-props="{
                    prevIcon: 'fa-solid fa-chevron-left',
                    nextIcon: 'fa-solid fa-chevron-right',
                    'items-per-page-text': 'Mostrando: ',
                    'items-per-page-options': [5, 10, 20, 30, 40, 50]
                }"
                hide-default-footer
            >
                <template v-slot:item="row">
                    <tr class="text-center">
                        <td>{{ row.item.wordpress_course_id }}</td>
                        <td>{{ row.item.wordpress_course_title }}</td>
                        <td>{{ row.item.ruta }}</td>
                        <td>{{ isOwnCourse(row.item.wordpress_course_id) ? 'Propio' : 'Utel X' }}</td>
                        <td>{{ row.item.countEstudiantesIniciados }}</td>
                        <td>{{ row.item.countEstudiantesAprobados }}</td>
                        <td>
                            <button @click="viewCourseUsers(row.item.id)" type="button" class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
                                alt="Ver usuarios" title="Ver usuarios">
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </td>
                        <td v-if="selectedTableType === 'owncourses'">
                            <button
                                type="button"
                                class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
                                alt="Editar curso"
                                title="Editar curso"
                                @click.prevent="onEditCourse(row.item.id)"
                            >
                                <i class="fa-regular fa-pen-to-square"></i>
                            </button>
                        </td>
                        <td v-if="selectedTableType === 'owncourses'">
                            <button
                                @click.prevent="openDeleteModal(row.item)"
                                type="button"
                                class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
                                alt="Eliminar curso"
                                title="Eliminar curso">
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </td>
                    </tr>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" color="info" icon="mdi-information">
                        No hay elementos disponibles.
                    </v-alert>
                </template>
                <template v-slot:footer>
                    <div class="text-center pt-2">
                        <v-pagination v-model="page" :length="pageCount" :total-visible="6" next-icon='fas fa-angle-right'
                            prev-icon='fas fa-angle-left' @input="getData"></v-pagination>
                    </div>
                </template>
            </v-data-table>
            <modaldelete
                v-if="deleteModalVisible"
                :course="selectedCourse"
                :url="url_delete_own_course"
                @reloadtable="onReloadTable"
                @close="closeDeleteModal"
            ></modaldelete>
        </div>
    </div>
</template>

<script>
import modaldelete from './ModalDeleteCourse.vue';

export default {
    props: ["uuid_client", "url_report", "url_report_detail", "url_report_detail_v2", "url_get", "url_add", "url_get_users", "url_get_own_courses", "url_delete_own_course"],
    components: {
        modaldelete
    },
    data() {
        return {
            search: '',
            headersTabs: [
                { text: "No.", value: "wordpress_course_id" },
                { text: "Curso", value: "wordpress_course_title" },
                { text: "Ruta", value: "ruta" },
                { text: "Tipo", value: "course_type"},
                { text: "Iniciado", value: "countEstudiantesIniciados" },
                { text: "Completado", value: "countEstudiantesAprobados" },
                { text: "Usuarios", value: "", align: 'center'},
            ],
            ownHeadersTabs: [
                { text: "Editar", value: "", align: 'center'},
                { text: "Eliminar", value: "", align: 'center'},
            ],
            allHeadersTabs: [],
            url: '',
            desserts: [],
            ownCourses: [],
            platformCourses: [],
            totalItems: 0,
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            deleteModalVisible: false,
            selectedCourse: {},
            selectedTableType: 'coursesroutes',
            loadingTable: true,
            searchTimeout: null
        }
    },
    mounted() {
        this.getData();
        this.allHeadersTabs = this.headersTabs;
    },
    created(){
        this.$parent.$on('onRefreshData', this.getData);
        window.scrollTo({ top: 0, behavior: 'smooth'});
    },
    computed: {},
    watch: {
        search() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.page = 1;
                this.getData();
            }, 400);
        }
    },
    methods: {
        getData(){
            this.loadingTable = true;
            this.selectedTableType = 'coursesroutes';
            
            let param = `?withUsers=true&page=${this.page}&per_page=${this.itemsPerPage}`;
            if (this.search) param += `&search=${this.search}`;

            axios.get(`${this.url_get}${param}`).then((res) => {
                if (res.data.data) {
                    this.platformCourses = res.data.data;
                    this.desserts = res.data.data;
                    this.totalItems = res.data.total;
                    this.page = res.data.current_page;
                    this.pageCount = res.data.last_page;
                } else {
                    this.platformCourses = res.data;
                    this.desserts = res.data;
                }
            }).finally(() => {
                this.loadingTable = false;
            });

            axios.get(this.url_get_own_courses).then((res) => {
                this.ownCourses = res.data;
            });
        },
        onFilterSearch(searchText) {
            this.search = searchText;
        },
        isOwnCourse(courseId){
            return this.ownCourses.filter(c => c.relation_type === 'wordpress').map(c => c.relation_id).includes(courseId);
        },
        viewCourseUsers(courseId){
            this.$emit('onViewCourseUsers', courseId);
        },
        editCourse(courseId){
            this.$emit('onEditCourse', courseId);
        },
        openDeleteModal(course){
            this.selectedCourse = course;
            this.deleteModalVisible = true;
        },
        closeDeleteModal(){
            this.deleteModalVisible = false;
        },
        onReloadTable(){
            this.getData();
            this.onTableTypeChange({target: { value: 'coursesroutes' }});
        },
        onTableTypeChange(event){
            const type = event.target.value;
            this.page = 1;
            if (type === 'owncourses') {
                this.desserts = this.ownCourses;
                this.allHeadersTabs = [...this.headersTabs, ...this.ownHeadersTabs];
                this.pageCount = Math.ceil(this.ownCourses.length / this.itemsPerPage);
            }else{
                this.desserts = this.platformCourses;
                this.allHeadersTabs = [...this.headersTabs];
                this.getData();
            }
        },
        onEditCourse(courseId){
            this.$emit('onEditCourse', courseId);
        },
        enviarReporte(){
            axios.get(this.url_report_detail_v2).then((res) => {
                alert("El reporte será enviado a su correo en unos minutos.");
            })
        }
    }
}
</script>
